"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _model = _interopRequireDefault(require("./model"));
function cov_gd2qxl9sd() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/product/lib/reducer.js";
  var hash = "cdcb74f3a5997dfe3b0ad247b5ad5e0419393a1b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/product/lib/reducer.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 35
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 16
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "2": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "3": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 34,
          column: 8
        }
      },
      "4": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 64
        }
      },
      "5": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      "6": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 48,
          column: 8
        }
      },
      "7": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 35
        }
      },
      "8": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 70
        }
      },
      "9": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 68,
          column: 8
        }
      },
      "10": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 75,
          column: 8
        }
      },
      "11": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 16
          },
          end: {
            line: 25,
            column: 17
          }
        },
        loc: {
          start: {
            line: 25,
            column: 83
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 25
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 17
          },
          end: {
            line: 25,
            column: 70
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 25,
            column: 25
          },
          end: {
            line: 25,
            column: 70
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 34,
            column: 8
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 42,
            column: 8
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 48,
            column: 8
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 51,
            column: 35
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 68,
            column: 8
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 75,
            column: 8
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 77,
            column: 19
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 63,
            column: 29
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 14
          },
          end: {
            line: 62,
            column: 26
          }
        }, {
          start: {
            line: 63,
            column: 14
          },
          end: {
            line: 63,
            column: 29
          }
        }],
        line: 61
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 61,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 61,
            column: 20
          }
        }, {
          start: {
            line: 61,
            column: 24
          },
          end: {
            line: 61,
            column: 39
          }
        }, {
          start: {
            line: 61,
            column: 43
          },
          end: {
            line: 61,
            column: 69
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 67,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 14
          },
          end: {
            line: 66,
            column: 26
          }
        }, {
          start: {
            line: 67,
            column: 14
          },
          end: {
            line: 67,
            column: 32
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 20
          }
        }, {
          start: {
            line: 65,
            column: 24
          },
          end: {
            line: 65,
            column: 42
          }
        }, {
          start: {
            line: 65,
            column: 46
          },
          end: {
            line: 65,
            column: 75
          }
        }],
        line: 65
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cdcb74f3a5997dfe3b0ad247b5ad5e0419393a1b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gd2qxl9sd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gd2qxl9sd();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
product = {
  LOADING : bool,
  ERROR : bool,
  name: string,
  rawName: {
    'fr': string,
    'en': string,
    ...
  },
  ...
}
*/
var productReducerInitialState = (cov_gd2qxl9sd().s[0]++, {
  LOADING: false,
  ERROR: false
});
/**
 * Reducer for the product object.
 * Should contains only one product with control variable
 * LOADING and ERROR that come from the load product.
 */
cov_gd2qxl9sd().s[1]++;
var product = function product() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_gd2qxl9sd().b[0][0]++, (0, _assign.default)({}, productReducerInitialState));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  cov_gd2qxl9sd().f[0]++;
  var newProduct;
  var occurrence;
  cov_gd2qxl9sd().s[2]++;
  switch (action.type) {
    // Empty the current product if any and return the LOADING state
    case 'PRODUCT_BEFORE_LOAD':
      cov_gd2qxl9sd().b[1][0]++;
      cov_gd2qxl9sd().s[3]++;
      return {
        LOADING: true,
        ERROR: false
      };
    // Receive data from the server, transform them and add product
    case 'PRODUCT_LOAD_SUCCESS':
      cov_gd2qxl9sd().b[1][1]++;
      cov_gd2qxl9sd().s[4]++;
      newProduct = _model.default.get(action.data, action.config);
      cov_gd2qxl9sd().s[5]++;
      return _objectSpread(_objectSpread({}, newProduct), {}, {
        LOADING: false,
        ERROR: false
      });
    // Receive an error from the server, remove any data about the product and set ERROR
    case 'PRODUCT_LOAD_ERROR':
      cov_gd2qxl9sd().b[1][2]++;
      cov_gd2qxl9sd().s[6]++;
      return {
        LOADING: false,
        ERROR: true
      };
    // clone a product from another product nucleo (pass the nucleo state as product value)
    case 'PRODUCT_CLONE':
      cov_gd2qxl9sd().b[1][3]++;
      cov_gd2qxl9sd().s[7]++;
      return _objectSpread({}, action.product);
    // having a product with a list of occurrences, we want to have the representation of a specific occurrence
    // To do so, retrieve the occurrence we want and make the list of occurrences (timeslot or performance) equals
    // to an array containing only the occurrence we selected (if no occurrence is found, get the complete list instead)
    // the options are directly send to the model
    case 'PRODUCT_SELECT_OCCURRENCE':
      cov_gd2qxl9sd().b[1][4]++;
      cov_gd2qxl9sd().s[8]++;
      occurrence = _model.default.findOccurrence(state, action.options);
      cov_gd2qxl9sd().s[9]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        timeslots: (cov_gd2qxl9sd().b[3][0]++, occurrence) && (cov_gd2qxl9sd().b[3][1]++, state.timeslots) && (cov_gd2qxl9sd().b[3][2]++, state.timeslots.length > 0) ? (cov_gd2qxl9sd().b[2][0]++, [occurrence]) : (cov_gd2qxl9sd().b[2][1]++, state.timeslots),
        performances: (cov_gd2qxl9sd().b[5][0]++, occurrence) && (cov_gd2qxl9sd().b[5][1]++, state.performances) && (cov_gd2qxl9sd().b[5][2]++, state.performances.length > 0) ? (cov_gd2qxl9sd().b[4][0]++, [occurrence]) : (cov_gd2qxl9sd().b[4][1]++, state.performances)
      });
    case 'PRODUCT_SET_PRICE':
      cov_gd2qxl9sd().b[1][5]++;
      cov_gd2qxl9sd().s[10]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        tariffs: action.tariffs,
        tariffsBySeatCat: action.tariffsBySeatCat
      });
    default:
      cov_gd2qxl9sd().b[1][6]++;
      cov_gd2qxl9sd().s[11]++;
      return state;
  }
};
var _default = exports.default = product;